'use client';

import { useTenantSelection } from '@payloadcms/plugin-multi-tenant/client';
import { useEffect, useRef } from 'react';

import { deleteCookie, getCookie } from '../../utils/cookies';

const PRESELECT_COOKIE = 'payload-tenant-preselect';

const TenantPreselect = () => {
  const { options, setTenant } = useTenantSelection();
  const applied = useRef(false);

  useEffect(() => {
    if (applied.current) return;

    const preselect = getCookie(PRESELECT_COOKIE);
    if (!preselect) return;

    if (!options.length) return;

    applied.current = true;
    deleteCookie(PRESELECT_COOKIE);
    setTenant({ id: preselect, refresh: true });
  }, [options, setTenant]);

  return null;
};

export default TenantPreselect;
